"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HoverMenuBase = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const Box_1 = tslib_1.__importDefault(require("@mui/material/Box"));
const List_1 = tslib_1.__importDefault(require("@mui/material/List"));
const Paper_1 = tslib_1.__importDefault(require("@mui/material/Paper"));
const Popper_1 = tslib_1.__importDefault(require("@mui/material/Popper"));
const Typography_1 = tslib_1.__importDefault(require("@mui/material/Typography"));
const ArrowLeft_1 = require("../components/ArrowLeft");
const MneListSubheader_1 = tslib_1.__importDefault(require("../components/MneListSubheader"));
const MenuItem_1 = tslib_1.__importDefault(require("./MenuItem"));
const HoverMenuBase = (props) => {
    const { children, content, openMenu, label } = props;
    const [anchorEl, setAnchorEl] = (0, react_1.useState)(null);
    const [arrowRef, setArrowRef] = (0, react_1.useState)(null);
    const handleMouseEnter = (e) => {
        setAnchorEl(e.currentTarget);
    };
    const handleMouseLeave = () => {
        setAnchorEl(null);
    };
    /**
     * We don't want to trigger the popper if the menu is on the `open` state.
     */
    const isHovered = Boolean(anchorEl) && !openMenu;
    return (react_1.default.createElement(Box_1.default, { onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, 
        // Keeps "hover" color on menu item while popper is hovered.
        sx: [
            isHovered && {
                ".MuiButtonBase-root": { background: (theme) => theme.palette.action.hover },
                ".SearchHoverOverlay": { background: (theme) => theme.palette.action.hover },
            },
        ] },
        children,
        react_1.default.createElement(Popper_1.default, { sx: { zIndex: (theme) => theme.zIndex.modal }, anchorEl: anchorEl, open: isHovered, placement: "right-start", modifiers: [
                {
                    name: "offset",
                    options: {
                        offset: label ? [-40, 8] : [-8, 8],
                    },
                },
                {
                    name: "arrow",
                    enabled: true,
                    options: {
                        element: arrowRef,
                    },
                },
            ] },
            react_1.default.createElement(Paper_1.default, { elevation: 1, sx: { marginLeft: 2 } }, content),
            react_1.default.createElement(Box_1.default, { "data-popper-arrow": true, ref: setArrowRef },
                react_1.default.createElement(ArrowLeft_1.ArrowLeft, { elevation: 1, sx: { left: "4px", top: "-6px" } })))));
};
exports.HoverMenuBase = HoverMenuBase;
const HoverMenu = (props) => {
    const { children, menuItems = [], ...rest } = props;
    return (react_1.default.createElement(exports.HoverMenuBase, { ...rest, children: children, content: react_1.default.createElement(List_1.default, { sx: { mx: 1 } },
            react_1.default.createElement(MneListSubheader_1.default, null,
                react_1.default.createElement(Typography_1.default, { variant: "overline" }, props.label)),
            menuItems.map((item) => (react_1.default.createElement(MenuItem_1.default, { open: true, key: item.label, hideIcon: true, ListItemTextProps: { sx: { paddingLeft: 0, paddingRight: 2 } }, ...item })))) }));
};
exports.default = HoverMenu;
